.wrapper {
  --wrapper-margin-block-end: initial;
  --wrapper-margin-block-start: initial;
  --wrapper-margin-inline-end: initial;
  --wrapper-margin-inline-start: initial;
  --wrapper-padding-block-end: initial;
  --wrapper-padding-block-start: initial;
  --wrapper-padding-inline-end: initial;
  --wrapper-padding-inline-start: initial;
  --wrapper-radius-bottom-end: initial;
  --wrapper-radius-bottom-start: initial;
  --wrapper-radius-top-end: initial;
  --wrapper-radius-top-start: initial;

  border-end-end-radius: var(--wrapper-radius-bottom-end);
  border-end-start-radius: var(--wrapper-radius-bottom-start);
  border-start-end-radius: var(--wrapper-radius-top-end);
  border-start-start-radius: var(--wrapper-radius-top-start);
  margin-block-end: var(--wrapper-margin-block-end);
  margin-block-start: var(--wrapper-margin-block-start);
  margin-inline-end: var(--wrapper-margin-inline-end);
  margin-inline-start: var(--wrapper-margin-inline-start);
  padding-block-end: var(--wrapper-padding-block-end);
  padding-block-start: var(--wrapper-padding-block-start);
  padding-inline-end: var(--wrapper-padding-inline-end);
  padding-inline-start: var(--wrapper-padding-inline-start);
}

.wrapper--border-top {
  border-top: var(--rc-theme-border-base);
}

.wrapper--border-bottom {
  border-bottom: var(--rc-theme-border-base);
}

.wrapper--border-left {
  border-left: var(--rc-theme-border-base);
}

.wrapper--border-right {
  border-right: var(--rc-theme-border-base);
}
